<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.status"
          @keydown.esc="dialog.status = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="pa-8 pt-6">
            <v-card-title 
              class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
              
              Mengubah Status

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon> -->

              <v-icon 
                @click="dialog.status = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <!-- <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
              Apakah Anda yakin mengubah status perubahan data menjadi <b class="font-weight-bold black--text">di{{ message.status }}</b> ?

              <!-- <div>
                <ValidationObserver 
                  ref="form">
                  <v-form>

                    <div
                      class="mb-6 mt-5"  v-if="message.status === 'tolak'">
                      <ValidationProvider 
                        name="Alasan" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Alasan
                        </div>

                        <v-textarea
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense
                          rows="3"
                          solo

                          :color="set_color"
                          placeholder="Contoh. Tuliskan alasan disini . . ."


                          v-model="rejected_reason"
                          :error-messages="errors"
                          style="border-radius: 10px;">
                        </v-textarea>
                      </ValidationProvider>
                    </div>
                    

                    <div
                      class="mb-6 mt-5" v-if="message.status === 'terima' && approved_by.length > 0">
                      <ValidationProvider 
                        name="Alasan" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Alasan
                        </div>

                        <v-textarea
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense
                          rows="3"
                          solo

                          :color="set_color"
                          placeholder="Contoh. Tuliskan alasan disini . . ."


                          v-model="approved_reason"
                          :error-messages="errors"
                          style="border-radius: 10px;">
                        </v-textarea>
                      </ValidationProvider>
                    </div>
                    
                  </v-form>
                </ValidationObserver>
              </div> -->

              <div v-if="message.error.length > 0"
                class="text-left mt-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>


            <!-- <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-actions
              class="pa-0 pt-4">
              <v-spacer/>

              <v-btn
                @click="message.status === 'batalkan' ? saveBatalkan() : saveStatus()"
                :loading="process.form"
                :disabled="process.form"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, {{ message.status }}
              </v-btn>

              <!-- <v-btn
                rounded
                width="120"
                @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                :disabled="process.status"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.freeze"
          @keydown.esc="dialog.freeze = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Freeze Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div 
                        class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Freeze"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in configHeaders" 
                            :key="index"
                            class="px-0"
                            @click="item.freeze = !item.freeze ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.freeze">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.freeze ? 'font-weight-bold' : ''"
                                :style="item.freeze ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.freeze = false; dialog.fullscreen = false; addFreezes();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Freeze
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.hide"
          @keydown.esc="dialog.hide = false"
          :fullscreen="dialog.fullscreen"
          width="400"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pt-3 pb-0 text-right popup-header">
              Hide Kolom

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.hide = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mt-3 mb-2"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-text 
              class="py-0">
              <v-form>
                <v-row>
                  <v-col>
                    <div>
                      <div class="mb-2">
                        Silahkan pilih kolom yang akan di <b class="font-italic">"Hide"</b>
                      </div>

                      <v-list-item-group
                        multiple>
                        <v-list flat>
                          <v-list-item 
                            v-for="(item, index) in headers" 
                            :key="index"
                            class="px-0"
                            @click="item.hide = !item.hide ? true : false">
                            <v-list-item-action 
                              class="mr-4">
                              <v-checkbox
                                :color="set_color"
                                :input-value="item.hide">
                              </v-checkbox>
                            </v-list-item-action>

                            <v-list-item-content>
                              <div
                                :class="item.hide ? 'font-weight-bold' : ''"
                                :style="item.hide ? `color: ${set_color};` : ''">
                                {{ item.text }}
                              </div>
                            </v-list-item-content>
                          </v-list-item>  
                        </v-list>
                      </v-list-item-group>
                    </div>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>

            <v-divider 
              class="mb-3 mt-0"
              style="border-top: 2px dashed #EBEBEB;"/>

            <v-card-actions
              class="mb-2">
              <v-spacer/>

              <v-btn
                elevation="0"
                :color="set_color"
                style="border-radius: 10px;"
                class="body-2 font-weight-bold text-capitalize white--text"
                @click="dialog.hide = false; dialog.fullscreen = false; addHides();">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Hide
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Tambah Pengecualian
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    name="Pilih Bulan" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Pilih Bulan
                    </div>

                    <v-autocomplete
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Contoh. Januari"

                      hide-details
                      :items="months"
                      item-text="text"
                      item-value="value"
                      multiple

                      v-model="form.bulan"
                      :success="form.bulan !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.bulan !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Catatan" 
                    rules="required" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Catatan
                    </div>

                    <v-textarea
                      v-on:keyup.enter="save()"
                      
                      filled
                      rounded
                      dense
                      rows="3"
                      

                      :color="set_color"
                      placeholder="Contoh. Tuliskan catatan disini . . ."

                      v-model="form.reason"
                      :success="form.reason !== '' && valid"
                      :error-messages="errors"
                      required
                      class="mb-6"
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>

                        <div v-if="form.reason !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-textarea>
                  </ValidationProvider>

                  <div v-if="form.filename === ''">
                    <uploadpdf 
                      v-model="upload.doc">
                      <div 
                        slot="activator">
                        <v-card
                          flat
                          class="cursor-pointer"
                          style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                          <v-card-text
                            class="py-2">
                            <div v-if="!process.doc"
                              class="d-flex align-center justify-center">
                              <v-icon 
                                size="28" 
                                color="#b6b6b6">
                                mdi-cloud-upload-outline
                              </v-icon>

                              <div
                                class="black--text ml-2"
                                style="opacity: 40%; font-weight: 500;">
                                Upload File
                              </div>
                            </div>

                            <div v-if="process.doc"
                              class="text-center">
                              <v-progress-circular
                                indeterminate
                                size="28"
                                color="#b6b6b6">
                              </v-progress-circular>
                            </div>
                          </v-card-text>
                        </v-card>
                      </div>
                    </uploadpdf>
                  </div>

                  <div v-if="form.filename !== ''">
                    <v-card
                      flat
                      style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                      <v-icon
                        @click="form.filename = ''"
                        color="red"
                        class="cursor-pointer"
                        style="position: absolute; top: -10px; right: -10px;">
                        mdi-close-circle
                      </v-icon>

                      <v-card-text
                        class="py-3 line-text-second">
                        <iframe
                          :src="form.filename"
                          width="100%"
                          height="250">
                        </iframe>
                        <!-- <div
                          class="d-flex align-center">
                          <div style="width: 50px;">Nama</div> : {{ form.file_text }}
                        </div>

                        <div
                          class="d-flex align-center">
                          <div style="width: 50px;">Size</div> : {{ Math.round(form.file_size / 1000) }} Kb
                        </div>

                        <div
                          class="d-flex align-center">
                          <div style="width: 50px;">Mime</div> : {{ form.file_mime }}
                        </div> -->

                        <!-- <div
                          class="d-flex align-center">
                          <div style="width: 50px;">Url</div> : <a :href="form.filename" target="_blank" class="ml-1">{{ form.filename }}</a>
                        </div> -->
                      </v-card-text>
                    </v-card>
                  </div>

                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false;"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.detail"
          @keydown.esc="dialog.detail = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Detail Pengecualian
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.detail = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>
              <v-card-text
                v-if="process.detail" 
                class="pb-0 my-4" 
                style="height: 400px; display: flex; align-items: center; justify-content: center;">
                <div class="text-center">
                  <div class="mb-4 title">
                    Mohon Tunggu . . .
                  </div>

                  <v-progress-linear
                    :color="set_color"
                    indeterminate
                    rounded
                    height="10">
                  </v-progress-linear>
                </div>
              </v-card-text>
            <v-card-text 
              class="py-0 my-4"
              v-if="!process.detail">
              <div>
                <div class="mb-3">
                  <div class="" style="font-size: 14px;">
                    Nama Unit
                  </div>
                  <div class="body-1 black--text">
                    {{ detail_pengecualian.unit_name }}
                  </div>
                </div>

                <div class="mb-3">
                  <div class="" style="font-size: 14px;">
                    Nama Sub Kegiatan
                  </div>
                  <div class="body-1 black--text">
                    {{ detail_pengecualian.task_title }}
                  </div>
                </div>

                <div class="mb-3">
                  <div class="" style="font-size: 14px;">
                    Tanggal Pengajuan
                  </div>
                  <div class="body-1 black--text">
                    {{ detail_pengecualian.date | date }}
                  </div>
                </div>

                <div class="mb-3">
                  <div class="" style="font-size: 14px;">
                    Bulan
                  </div>
                  <div class="body-1 black--text">
                    <span v-if="detail_pengecualian.bulan_1 === '1'">
                      {{ detail_pengecualian.bulan_1 === '1' ? 'Januari' : '' }}
                    </span>
                    <span v-if="detail_pengecualian.bulan_2 === '1'">
                      <span v-if="detail_pengecualian.bulan_1 === '1'">, </span>
                      {{ detail_pengecualian.bulan_2 === '1' ? 'Februari' : '' }}
                    </span>
                    <span v-if="detail_pengecualian.bulan_3 === '1'">
                      <span v-if="detail_pengecualian.bulan_1 === '1' || detail_pengecualian.bulan_2 === '1'">, </span>
                      {{ detail_pengecualian.bulan_3 === '1' ? 'Maret' : '' }}
                    </span>
                    <span v-if="detail_pengecualian.bulan_4 === '1'">
                      <span v-if="detail_pengecualian.bulan_1 === '1' || detail_pengecualian.bulan_2 === '1' || detail_pengecualian.bulan_3 === '1'">, </span>
                      {{ detail_pengecualian.bulan_4 === '1' ? 'April' : '' }}
                    </span>
                    <span v-if="detail_pengecualian.bulan_5 === '1'">
                      <span v-if="detail_pengecualian.bulan_1 === '1' || detail_pengecualian.bulan_2 === '1' || detail_pengecualian.bulan_3 === '1' || detail_pengecualian.bulan_4 === '1'">, </span>
                      {{ detail_pengecualian.bulan_5 === '1' ? 'Mei' : '' }}
                    </span>
                    <span v-if="detail_pengecualian.bulan_6 === '1'">
                      <span v-if="detail_pengecualian.bulan_1 === '1' || detail_pengecualian.bulan_2 === '1' || detail_pengecualian.bulan_3 === '1' || detail_pengecualian.bulan_4 === '1' || detail_pengecualian.bulan_5 === '1'">, </span>
                      {{ detail_pengecualian.bulan_6 === '1' ? 'Juni' : '' }}
                    </span>
                    <span v-if="detail_pengecualian.bulan_7 === '1'">
                      <span v-if="detail_pengecualian.bulan_1 === '1' || detail_pengecualian.bulan_2 === '1' || detail_pengecualian.bulan_3 === '1' || detail_pengecualian.bulan_4 === '1' || detail_pengecualian.bulan_5 === '1' || detail_pengecualian.bulan_6 === '1'">, </span>
                      {{ detail_pengecualian.bulan_7 === '1' ? 'Juli' : '' }}
                    </span>
                    <span v-if="detail_pengecualian.bulan_8 === '1'">
                      <span v-if="detail_pengecualian.bulan_1 === '1' || detail_pengecualian.bulan_2 === '1' || detail_pengecualian.bulan_3 === '1' || detail_pengecualian.bulan_4 === '1' || detail_pengecualian.bulan_5 === '1' || detail_pengecualian.bulan_6 === '1' || detail_pengecualian.bulan_7 === '1'">, </span>
                      {{ detail_pengecualian.bulan_8 === '1' ? 'Agustus' : '' }}
                    </span>
                    <span v-if="detail_pengecualian.bulan_9 === '1'">
                      <span v-if="detail_pengecualian.bulan_1 === '1' || detail_pengecualian.bulan_2 === '1' || detail_pengecualian.bulan_3 === '1' || detail_pengecualian.bulan_4 === '1' || detail_pengecualian.bulan_5 === '1' || detail_pengecualian.bulan_6 === '1' || detail_pengecualian.bulan_7 === '1' || detail_pengecualian.bulan_8 === '1'">, </span>
                      {{ detail_pengecualian.bulan_9 === '1' ? 'September' : '' }}
                    </span>
                    <span v-if="detail_pengecualian.bulan_10 === '1'">
                      <span v-if="detail_pengecualian.bulan_1 === '1' || detail_pengecualian.bulan_2 === '1' || detail_pengecualian.bulan_3 === '1' || detail_pengecualian.bulan_4 === '1' || detail_pengecualian.bulan_5 === '1' || detail_pengecualian.bulan_6 === '1' || detail_pengecualian.bulan_7 === '1' || detail_pengecualian.bulan_8 === '1' || detail_pengecualian.bulan_9 === '1'">, </span>
                      {{ detail_pengecualian.bulan_10 === '1' ? 'Oktober' : '' }}
                    </span>
                    <span v-if="detail_pengecualian.bulan_11 === '1'">
                      <span v-if="detail_pengecualian.bulan_1 === '1' || detail_pengecualian.bulan_2 === '1' || detail_pengecualian.bulan_3 === '1' || detail_pengecualian.bulan_4 === '1' || detail_pengecualian.bulan_5 === '1' || detail_pengecualian.bulan_6 === '1' || detail_pengecualian.bulan_7 === '1' || detail_pengecualian.bulan_8 === '1' || detail_pengecualian.bulan_9 === '1' || detail_pengecualian.bulan_10 === '1'">, </span>
                      {{ detail_pengecualian.bulan_11 === '1' ? 'November' : '' }}
                    </span>
                    <span v-if="detail_pengecualian.bulan_12 === '1'">
                      <span v-if="detail_pengecualian.bulan_1 === '1' || detail_pengecualian.bulan_2 === '1' || detail_pengecualian.bulan_3 === '1' || detail_pengecualian.bulan_4 === '1' || detail_pengecualian.bulan_5 === '1' || detail_pengecualian.bulan_6 === '1' || detail_pengecualian.bulan_7 === '1' || detail_pengecualian.bulan_8 === '1' || detail_pengecualian.bulan_9 === '1' || detail_pengecualian.bulan_10 === '1' || detail_pengecualian.bulan_11 === '1'">, </span>
                      {{ detail_pengecualian.bulan_12 === '1' ? 'Desember' : '' }}
                    </span>
                  </div>
                </div>

                <div class="mb-3">
                  <div class="" style="font-size: 14px;">
                    Status
                  </div>
                  <div class="body-1 text-capitalize font-weight-bold" :class="detail_pengecualian.status === 'diterima' ? 'green--text' : detail_pengecualian.status === 'ditolak' ? 'red--text' : detail_pengecualian.status === 'dibatalkan' ? 'orange--text' : 'black--text'">
                    {{ detail_pengecualian.status }}
                  </div>
                </div>

                <div class="mb-3">
                  <div class="" style="font-size: 14px;">
                    Catatan
                  </div>
                  <div class="body-1 black--text">
                    {{ detail_pengecualian.reason === '' ? '-' : detail_pengecualian.reason }}
                  </div>
                </div>

                <div class="mb-3">
                  <div class="" style="font-size: 14px;">
                    File
                  </div>
                  <div class="body-1 black--text">
                    <div v-if="detail_pengecualian.filename === ''">
                      -
                    </div>
                    <div v-if="detail_pengecualian.filename !== ''">
                      <iframe
                        :src="detail_pengecualian.filename"
                        width="100%"
                        height="250">
                      </iframe>
                      <v-btn
                        target="_blank"
                        :href="detail_pengecualian.filename"
                        width="120"
                        elevation="0"
                        color="primary"
                        rounded
                        class="body-2 font-weight-bold text-capitalize white--text mt-2">
                        Buka File
                      </v-btn>
                    </div>
                  </div>
                </div>
              </div>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="dialog.status = true; message.error = ''; message.success = ''; message.status = 'terima';"
                :loading="process.form"
                :disabled="process.form"
                v-if="detail_pengecualian.status === 'menunggu' && user.role === 'admin'"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Terima
              </v-btn>

              <v-btn
                @click="dialog.status = true; message.error = ''; message.success = ''; message.status = 'tolak';"
                :loading="process.form"
                :disabled="process.form"
                v-if="detail_pengecualian.status === 'menunggu' && user.role === 'admin'"
                width="120"
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Tolak
              </v-btn>

              <v-btn
                @click="dialog.status = true; message.error = ''; message.success = ''; message.status = 'batalkan';"
                :loading="process.form"
                :disabled="process.form"
                v-if="detail_pengecualian.status === 'menunggu' && user.role !== 'admin'"
                width="120"
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batalkan
              </v-btn>
              
              <v-btn
                @click="dialog.status = true; message.error = ''; message.success = ''; message.status = 'batalkan';"
                :loading="process.form"
                :disabled="process.form"
                v-if="detail_pengecualian.status === 'diterima' && user.role === 'admin'"
                width="120"
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batalkan
              </v-btn>


              <v-btn
                @click="dialog.detail = false;"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                to="/program-p1"
                flat
                color="transparent">
                <div
                  class="d-flex align-center">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="28"
                      style="opacity: 30%;">
                      <v-img
                        contain
                        alt="kominfoklaten"  
                        :src="require('@/assets/icon/back_arrow.png')">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="title black--text ml-3"
                      style="font-weight: 600;">
                      <span v-if="detail.type === 'Program'">
                        Program
                      </span>

                      <span v-if="detail.type === 'Kegiatan'"
                        class="d-flex align-center">
                        <span>
                          Program
                        </span>

                        <v-icon size="20" class="mx-1" style="opacity: 70%;">mdi-arrow-right</v-icon>

                        <span>
                          Kegiatan
                        </span>
                      </span>

                      <span v-if="detail.type === 'Sub Kegiatan'"
                        class="d-flex align-center">
                        <!-- <span>
                          Program
                        </span>

                        <v-icon size="20" class="mx-1" style="opacity: 70%;">mdi-arrow-right</v-icon>

                        <span>
                          Kegiatan
                        </span>

                        <v-icon size="20" class="mx-1" style="opacity: 70%;">mdi-arrow-right</v-icon> -->

                        <span>
                          Pengecualian Sub Kegiatan
                        </span>
                      </span>
                    </span>
                  </div>

                  <v-spacer />

                  <!-- <div v-if="user.role === 'admin'">
                    <v-btn
                      :to="`/program-p1/edit/${detail.id}?from=detail&unit_id=${$route.query.unit_id}&year=${$route.query.year}`"
                      color="#4B4B4B"
                      elevation="0"
                      class="body-2 white--text text-capitalize d-flex align-center"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(31, 150, 243, 1), rgba(25, 110, 176, 1));">
                      <v-icon size="20">mdi-progress-pencil</v-icon>
                      
                      <span
                        class="ml-2">
                        Ubah
                      </span>
                    </v-btn>
                  </div> -->
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                class="mb-5"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text>
                  <div
                    class="body-1 font-weight-bold black--text mb-4">
                    #General
                  </div>

                  <v-row>
                    <v-col
                      cols="3"
                      class="py-0">
                      <div
                        class="black--text d-flex align-center mb-2">
                        {{ detail.type }}

                        <v-spacer />

                        :
                      </div>
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0 pl-0">
                      <div
                        class="black--text mb-2">
                        {{ detail.code }} {{ detail.code !== '' ? '-' : '' }} {{ detail.title }}
                      </div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="3"
                      class="py-0">
                      <div
                        class="black--text d-flex align-center mb-2">
                        Anggaran (RENJA)

                        <v-spacer />

                        :
                      </div>
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0 pl-0">
                      <div
                        class="black--text font-weight-bold mb-2">
                        {{ parseInt(detail.anggaran) | price }}
                      </div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="3"
                      class="py-0">
                      <div
                        class="black--text d-flex align-center mb-2">
                        Anggaran P1

                        <v-spacer />

                        :
                      </div>
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0 pl-0">
                      <div
                        class="black--text font-weight-bold mb-2">
                        {{ parseInt(detail.anggaran_p1) | price }}
                      </div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="3"
                      class="py-0">
                      <div
                        class="black--text d-flex align-center mb-2">
                        Anggaran Terakhir (PERUBAHAN)

                        <v-spacer />

                        :
                      </div>
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0 pl-0">
                      <div
                        class="black--text font-weight-bold mb-2">
                        {{ parseInt(detail.anggaran_perubahan) | price }}
                      </div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="3"
                      class="py-0">
                      <div
                        class="black--text d-flex align-center mb-2">
                        Tahun Anggaran

                        <v-spacer />

                        :
                      </div>
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0 pl-0">
                      <div
                        class="black--text mb-2">
                        {{ detail.tahun_anggaran }}
                      </div>
                    </v-col>
                  </v-row>
                  
                  <v-row>
                    <v-col
                      cols="3"
                      class="py-0">
                      <div
                        class="black--text d-flex align-center mb-2">
                        PPKOM

                        <v-spacer />

                        :
                      </div>
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0 pl-0">
                      <div
                        class="black--text mb-2">
                        {{ detail.ppkom_name !== '' ? detail.ppkom_name : '-' }}
                      </div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="3"
                      class="py-0">
                      <div
                        class="black--text d-flex align-center">
                        PPTK

                        <v-spacer />

                        :
                      </div>
                    </v-col>

                    <v-col
                      cols="9"
                      class="py-0 pl-0">
                      <div
                        class="black--text">
                        {{ detail.pptk_name !== '' ? detail.pptk_name : '-' }}
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- <v-card 
                flat
                class="mb-5"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text>

                </v-card-text>
              </v-card> -->
              <v-row v-if="detail.type === 'Sub Kegiatan' && user.role !== 'admin'"
                justify="end">
                <v-col
                  cols="2" class="text-right d-flex justify-end">
                  <v-btn
                    @click="dialog.form = true; reset();"
                    color="#4B4B4B"
                    elevation="0"
                    class="body-2 white--text text-capitalize d-flex align-center"
                    style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(31, 150, 243, 1), rgba(25, 110, 176, 1));">
                    <v-icon size="20">mdi-plus-circle-outline</v-icon>
                    
                    <span
                      class="ml-2">
                      Tambah
                    </span>
                  </v-btn>
                </v-col>
              </v-row>
              <v-card 
                flat
                class="mb-5"
                style="border-radius: 10px; border: 1px solid #E7E7E7;">
                <v-data-table
                  v-model="selected.row"
                  ref="table-grid"
                  class="table-grid"
                  :height="`calc(100vh - ${pagination.total_data > 0 ? '320px' : '248px'})`"
                  :show-select="checkbox"
                  :single-select="true"
                  :loading="process.load"
                  loading-text="Sedang memuat data . . ."
                  loader-height="5"
                  no-results-text="Belum ada data"
                  :options.sync="options"
                  :headers="configHeaders"
                  :items="list"
                  :items-per-page="100"
                  item-key="id"
                  @click:row="rowClick"
                  @toggle-select-all="handleToggleAll($event)"
                  @dblclick:row="doubleClick"
                  hide-default-footer>
                  <template
                    v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                    v-slot:[`item.${header.value}`]="{ value }">
                    <div
                      v-bind:key="header.value">
                      <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                        {{ rowFormat(header.format, value) }} 
                      </div>

                      <div v-if="header.format === 'link'"
                        class="cursor-pointer">
                        
                      </div>
        
                      <div v-if="header.format === 'regex'">
                        <span
                          class="two-line">
                          {{ rowFormat(header.format, value) }}
                        </span>
                      </div>
        
                      <div v-if="header.format === 'image'"
                        class="ma-4">
                        <v-avatar
                          size="60"
                          tile
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <v-img 
                            contain
                            width="100%"
                            height="100%"
                            alt="kominfoklaten" 
                            :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                            class="ma-auto">
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height"
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  size="20"
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </v-avatar>
                      </div>

                      <div v-if="header.format === 'image_potrait'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="100"
                          height="125"
                          alt="kominfoklaten" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'image_landscape'"
                        class="ma-4">
                        <v-img 
                          contain
                          width="200"
                          height="125"
                          alt="kominfoklaten" 
                          :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                          class="ma-auto"
                          style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height"
                              align="center"
                              justify="center">
                              <v-progress-circular 
                                size="20"
                                indeterminate 
                                :color="set_color">
                              </v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>

                      <div v-if="header.format === 'action'">
                        <v-tooltip 
                          right>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="detailDialog(value)"

                              v-bind="attrs"
                              v-on="on"

                              min-width="28"
                              small
                              rounded
                              color="green"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 6px;">
                              <v-icon small>mdi-information-outline</v-icon>
                            </v-btn>
                          </template>

                          <span>Detail</span>
                        </v-tooltip>
                      </div>

                      <div v-if="header.format === 'bool'"
                        class="d-flex align-center justify-center">
                        
                      </div>

                      <div v-if="header.format === 'status'"
                        class="d-flex" :class="value === 'diterima' ? 'green--text' : value === 'ditolak' ? 'red--text' : value === 'dibatalkan' ? 'orange--text' : 'black--text'">
                        {{ value === 'menunggu' ? 'Menunggu' : value === 'diterima' ? 'Diterima' : value === 'ditolak' ? 'Ditolak' : 'Dibatalkan' }}
                      </div>
                    </div>
                  </template>

                  <template v-slot:[`item.index`]="{ index }">
                    {{ lastIndex + index }}
                  </template>

                  <v-progress-linear 
                    v-show="process.load" 
                    slot="progress" 
                    color="white" 
                    indeterminate>
                  </v-progress-linear>
                </v-data-table>

                <pagination v-if="pagination.total_data > 0"
                  @changePage="fetch($event)" 
                  @reloadPage="fetch($event)" 
                  :model="pagination"/>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,

        expanded_program: [],
        expanded_kegiatan: [],

        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,
          form: false,
          status: false,
          detail: false
        },
        
        search: '',

        selected: {
          row: [],

          freeze: []
        },

        upload: {
          doc: false
        },

        form: {
          task_id: '',
          bulan: [],
          filename: '',
          file_text: '',
          file_size: '',
          file_mime: '',
          reason: ''
        },

        detail_pengecualian: {},

        detail: {},
        target_dan_realisasi: [],

        target_keuangan: [],
        target_fisik: [],

        realisasi_keuangan: [],
        realisasi_fisik: [],

        options: {},
        headers: [],
        list: [],
        pagination: {},

        lastIndex: 0,
        limit: 20,

        bar_target: {},
        bar_realisasi: {},

        process: {
          load: false,
          detail: false,
          form: false,
          doc: false
        },
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue'),
      uploadpdf: () => import(/* webpackPrefetch: true */ '@/components/upload/pdf.vue')
    },
    watch: {
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetch(pagination)
        },
        deep: true
      },
      'upload.doc': {
        handler: function () {
          if (this.upload.doc) {
            this.process.doc = this.upload.doc.process

            if (!this.process.doc) {
              // CALLBACK FROM UPLOAD DOC
              
              this.form.filename = this.upload.doc.fileuri

              this.form.file_text = this.upload.doc.filename
              this.form.file_size = this.upload.doc.filesize
              this.form.file_mime = this.upload.doc.filemime

              this.process.doc = false

              // console.log(this.form.filename)
            }
          }
        },
        deep: true
      }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },
      months () {
        let numb = new Date().getMonth() + 1
        

        return [
          {
            text: 'Januari',
            value: 1
          },
          {
            text: 'Februari',
            value: 2
          },
          {
            text: 'Maret',
            value: 3
          },
          {
            text: 'April',
            value: 4
          },
          {
            text: 'Mei',
            value: 5
          },
          {
            text: 'Juni',
            value: 6
          },
          {
            text: 'Juli',
            value: 7
          },
          {
            text: 'Agustus',
            value: 8
          },
          {
            text: 'September',
            value: 9
          },
          {
            text: 'Oktober',
            value: 10
          },
          {
            text: 'November',
            value: 11
          },
          {
            text: 'Desember',
            value: 12
          }
        ]
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }

        await get('admin/task/detail', { params })
        .then(response => {
          let res = response.data

          this.process.load = false
            
          if (res.status === 200) {
            this.detail = res.results.data

            let tdr = [],
                target_uang = [],
                target_fisik = [],
                realisasi_uang = [],
                realisasi_fisik = []

            target_uang = [
              this.detail.target_keu_1,
              this.detail.target_keu_2,
              this.detail.target_keu_3,
              this.detail.target_keu_4,
              this.detail.target_keu_5,
              this.detail.target_keu_6,
              this.detail.target_keu_7,
              this.detail.target_keu_8,
              this.detail.target_keu_9,
              this.detail.target_keu_10,
              this.detail.target_keu_11,
              this.detail.target_keu_12
            ]

            target_fisik = [
              this.detail.target_fisik_1,
              this.detail.target_fisik_2,
              this.detail.target_fisik_3,
              this.detail.target_fisik_4,
              this.detail.target_fisik_5,
              this.detail.target_fisik_6,
              this.detail.target_fisik_7,
              this.detail.target_fisik_8,
              this.detail.target_fisik_9,
              this.detail.target_fisik_10,
              this.detail.target_fisik_11,
              this.detail.target_fisik_12
            ]

            realisasi_uang = [
              this.detail.realisasi_keu_1,
              this.detail.realisasi_keu_2,
              this.detail.realisasi_keu_3,
              this.detail.realisasi_keu_4,
              this.detail.realisasi_keu_5,
              this.detail.realisasi_keu_6,
              this.detail.realisasi_keu_7,
              this.detail.realisasi_keu_8,
              this.detail.realisasi_keu_9,
              this.detail.realisasi_keu_10,
              this.detail.realisasi_keu_11,
              this.detail.realisasi_keu_12
            ]

            realisasi_fisik = [
              this.detail.realisasi_fisik_1,
              this.detail.realisasi_fisik_2,
              this.detail.realisasi_fisik_3,
              this.detail.realisasi_fisik_4,
              this.detail.realisasi_fisik_5,
              this.detail.realisasi_fisik_6,
              this.detail.realisasi_fisik_7,
              this.detail.realisasi_fisik_8,
              this.detail.realisasi_fisik_9,
              this.detail.realisasi_fisik_10,
              this.detail.realisasi_fisik_11,
              this.detail.realisasi_fisik_12
            ]

            this.bar_target = {
              series: [
                
                {
                  name: 'Target Fisik',
                  data: target_fisik
                },
                {
                  name: 'Realisasi Fisik',
                  data: realisasi_fisik
                },
              ],
              chartOptions: {
                chart: {
                  animations: {
                    enabled: true,
                    easing: 'linear',
                    dynamicAnimation: {
                      speed: 1000
                    }
                  },
                  toolbar: {
                    show: true
                  },
                  zoom: {
                    enabled: true
                  }
                },
                stroke: {
                  width: 3,
                  curve: 'smooth'
                },
                dataLabels: {
                  enabled: true
                },
                colors: ['#FF9800', '#00BCD4', '#9C27B0', '#F44336', '#2196F3', '#4CAF50'],
                yaxis: {
                  labels: {
                    formatter: function (value) {
                      return Math.round(value)
                    }
                  }
                },
                xaxis: {
                  categories: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "Mei",
                    "Jun",
                    "Jul",
                    "Agu",
                    "Sep",
                    "Okt",
                    "Nov",
                    "Des"
                  ]
                }
              }
            }

            this.bar_realisasi = {
              series: [
                {
                  name: 'Target Keuangan',
                  data: target_uang
                },
                {
                  name: 'Realisasi Keuangan',
                  data: realisasi_uang
                }
              ],
              chartOptions: {
                chart: {
                  animations: {
                    enabled: true,
                    easing: 'linear',
                    dynamicAnimation: {
                      speed: 1000
                    }
                  },
                  toolbar: {
                    show: true
                  },
                  zoom: {
                    enabled: true
                  }
                },
                stroke: {
                  width: 3,
                  curve: 'smooth'
                },
                dataLabels: {
                  enabled: true
                },
                colors: ['#FF9800', '#00BCD4', '#9C27B0', '#F44336', '#2196F3', '#4CAF50'],
                yaxis: {
                  labels: {
                    formatter: function (value) {
                      return Math.round(value)
                    }
                  }
                },
                xaxis: {
                  categories: [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "Mei",
                    "Jun",
                    "Jul",
                    "Agu",
                    "Sep",
                    "Okt",
                    "Nov",
                    "Des"
                  ]
                }
              }
            }
          }
        })
      },

      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      handleToggle (event) {
        if (!event.value) this.selected.row = []
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },

      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },

      detailDialog(index) {
        this.dialog.detail = true
        this.fetchDetailPengecualian(index)
        // this.reset()
      },
      async fetchDetailPengecualian (id) {
        this.process.detail = true

        let params = {
          id: id
        }

        await get('admin/pengajuan/detail', { params })
        .then(response => {
          let res = response.data

          this.process.detail = false
            
          if (res.status === 200) {
            this.detail_pengecualian = res.results.data

          }
        })
      },

      reset () {
        if (this.$refs.form) this.$refs.form.reset()
        this.form = {
          task_id: '',
          bulan: [],
          filename: '',
          file_text: '',
          file_size: '',
          file_mime: '',
          reason: ''
        }

        this.message = {
          success: '',
          error: ''
        }
      },
      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? '-id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          search: this.search,
          unit_id: this.$route.query.unit_id,
          task_id: this.$route.params.id
        }

        this.selected.row = []

        await get(`admin/pengajuan/data`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          this.list = []
          this.pagination = {}
            
          if (res.status === 200) {
            this.headers = [
              {
                text: 'Aksi',
                width: '80px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'center',
                format: 'action'
              },
              {
                text: 'Tanggal Pengajuan',
                width: '200px',
                value: 'date',
                freeze: false,
                hide: false,
                format: 'date'
              },
              {
                text: 'Nama Unit',
                width: '100%',
                value: 'unit_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Status',
                width: '200px',
                value: 'status',
                freeze: false,
                format: 'status',
              }
              // {
              //   text: 'Nama Sub Kegiatan',
              //   width: '200px',
              //   value: 'task_title',
              //   freeze: false,
              //   hide: false
              // },
              // {
              //   text: 'Tanggal Pengajuan',
              //   width: '200px',
              //   value: 'date',
              //   freeze: false,
              //   hide: false,
              //   format: 'date'
              // }
            ]

            this.list = res.results.data
            this.pagination = res.results.pagination

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },

      async saveStatus () {
        this.message.error = ''

        this.process.form = true

        let params = {
          id: this.detail_pengecualian.id,
          status: this.message.status === 'terima' ? 'diterima' : this.message.status === 'batalkan' ? 'dibatalkan' : 'ditolak'
        }

        await post(`admin/pengajuan/approval`, { data: params })
        .then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {
            this.dialog.status = false

            this.fetchDetail()
            this.fetchDetailPengecualian(this.detail_pengecualian.id)
            this.fetch()
            this.dialog.snackbar = true
            this.message.success = res.message
            this.message.error = ''
          } else {
            this.message.error = res.message
          }
        })
      },

      async saveBatalkan () {
        this.message.error = ''

        this.process.form = true

        let params = {
          id: this.detail_pengecualian.id
        }

        await post(`admin/pengajuan/batalkan`, { data: params })
        .then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {
            this.dialog.status = false

            this.fetchDetail()
            this.fetchDetailPengecualian(this.detail_pengecualian.id)
            this.fetch()
            this.dialog.snackbar = true
            this.message.success = res.message
            this.message.error = ''
          } else {
            this.message.error = res.message
          }
        })
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          // SAVE TO REST API
          await post(`admin/pengajuan/add`, {
            data: {
              task_id: this.$route.params.id,
              bulan: (this.form.bulan).toString(),
              tahun_anggaran: this.$route.query.year,
              reason: this.form.reason,
              filename: this.form.filename,
            }
          })
          .then((response) => {
            let res = response.data

            this.process.form = false

            if (res.status === 200) {

              this.dialog.form = false
              
              this.fetchDetail()
              this.fetch()
              this.dialog.snackbar = true
              this.message.success = res.message
              this.message.error = ''

            } else {
              this.message.error = res.message
            }
          })
          
        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      }
    }
  }
</script>